import { Injectable } from '@angular/core';
import { DateUtils, PaxStateItem, PaxType, SearcherState } from '@vueling-ng/vy-cdk-searcher';

@Injectable({
  providedIn: 'root'
})
export class PassengerConfiguration {
  public minDaysForExtraSeatReservation = 3;

  public isSatisfiedBy(changedPax: PaxStateItem, state: SearcherState): boolean {
    if (changedPax.paxType === PaxType.ExtraSeats) {
      return this.isValidExtraSeat(changedPax, state);
    }
    return changedPax.value <= changedPax.max;
  }

  public isValidExtraSeat(changedPax: PaxStateItem, state: SearcherState): boolean {
    if (this.minDaysForExtraSeatReservation || changedPax.value === 0) {
      return true;
    }

    if (!state.outboundDate) return false;

    return (
      DateUtils.differenceInDays(new Date(), DateUtils.truncateUtcToLocalDate(state.outboundDate)) >=
      this.minDaysForExtraSeatReservation
    );
  }
}
